<template>
  <div class="transfer-balance-wrap">
    <div class="transfer-content">
      <div class="transfer-header">
        贈送好友nicee幣
      </div>
      <div class="transfer-count">
        <span>可贈送金額</span>
        <span>{{ currencyKind }}{{ reward }}</span>
      </div>
      <div class="transfer-text">
        <p>
          將收入贈送給好友，收入將以1:1換為nicee幣
          進入對方錢包賬戶，即時到賬。<br />
          夏日狂歡大派送！首次贈送金額超過＄1000，贈送方可額外獲得<span
            style="color:#FC2530"
            >1000鑽石</span
          >獎勵。
        </p>
      </div>
      <input
        class="transfer-input"
        v-model="transferNumber"
        @input="onInput"
        type="text"
        placeholder="贈送金額"
      />
      <input
        class="transfer-input"
        v-model="transferUuid"
        type="text"
        placeholder="受贈好友ID"
        maxlength="7"
      />
      <p class="error-text" v-if="transferNickname">
        受贈方暱稱：{{ transferNickname }}
      </p>
      <p class="error-text" v-if="!transferNickname && transferUuid">
        該用戶不存在
      </p>
      <div class="transfer-btn" @click="transferBalance">
        <i v-if="transferLoading" class="el-icon-loading"></i>
        確認兌換
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transferNumber: '',
      transferLoading: false,
      currencyKind: '$',
      reward: 0,
      transferNickname: '',
      transferUuid: '',
      searchUuidTimer: null
    };
  },
  watch: {
    transferUuid: {
      handler: function(nVal) {
        this.clearTimer();
        this.searchUuidTimer = setTimeout(() => {
          this.transferNickname = '';
          if (nVal.length >= 6) {
            this.getUserInfo(nVal);
          }
        }, 500);
      },
      immediate: true
    }
  },
  created() {
    this.getUserAccount();
  },
  methods: {
    onInput({ target }) {
      const { value } = target;
      // 使用正則錶達式驗證輸入值
      const regex = /^\d+(\.\d{0,2})?$/; // 隻允許數字和最多兩位小數
      if (regex.test(value)) {
        this.transferNumber = value;
      } else {
        // 小數點超過兩位時，截取前兩位小數
        const match = value.match(/^\d+(?:\.\d{0,2})?/);
        this.transferNumber = match ? match[0] : '';
      }
    },
    getUserAccount() {
      this.loading = true;
      this.$store
        .dispatch('app/getUserAccount')
        .then(data => {
          if (data) {
            this.currencyKind = data.currencyKind;
            this.reward = data.reward;
            this.init();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init() {
      this.transferNumber = '';
    },
    getUserInfo(uuid) {
      return this.$http
        .get('/user/nickname', {
          uuid
        })
        .then(({ data }) => {
          if (data.uuid === this.transferUuid) {
            this.transferNickname = data.nickname;
            return true;
          }
        })
        .catch(() => {
          this.transferNickname = '';
          return false;
        });
    },
    clearTimer() {
      if (!this.searchUuidTimer) return;
      clearTimeout(this.searchUuidTimer);
      this.searchUuidTimer = null;
    },
    transferBalance() {
      if (this.transferLoading) {
        return;
      }
      if (!this.validTransferUuid()) {
        return;
      }
      if (!this.validTransferNumber()) {
        return;
      }
      this.$confirm({
        content: `贈送${this.transferNumber}金額給${this.transferNickname}（${this.transferUuid}）`,
        confirmButtonText: '確認',
        cancelButtonText: '取消'
      }).then(() => {
        this.transferLoading = true;
        // 贈送收入給好友
        this.$http
          .post('/account/inner/transform2', {
            amount: this.transferNumber,
            toUserUuid: this.transferUuid
          })
          .then(() => {
            this.$message.success('贈送成功');
            this.transferLoading = false;
            this.getUserAccount();
            // this.$router.push({
            //   name: 'PlayerIncome'
            // });
          });
      });
    },
    validTransferNumber() {
      if (this.transferNumber > this.reward) {
        this.errorInfo('贈送金額超出可贈送');
        return false;
      }
      if (!this.transferNumber) {
        this.errorInfo('請填寫贈送金額');
        return false;
      }
      return true;
    },
    validTransferUuid() {
      if (!this.transferUuid || !this.transferNickname) {
        this.errorInfo('請輸入有效的好友ID');
        return false;
      }
      if (this.userInfo && this.transferUuid == this.userInfo.uuid) {
        this.errorInfo('無法贈送給自己');
        return false;
      }
      return true;
    },
    errorInfo(message) {
      this.$confirm({
        content: message,
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        showCancelButton: false
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.transfer-balance-wrap {
  width: 100%;
  height: 698px;
  margin-bottom: 60px !important;
  box-sizing: border-box;
  background: white;
  @include whiteBox;
  .transfer-header {
    width: 100%;
    height: 91px;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 31px;
    color: #333333;
    border-bottom: 2px solid #f4f4f4;
    line-height: 91px;
  }
  .transfer-content {
    width: 494px;
    padding-left: 40px;
    .transfer-count {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      margin: 35px 0 14px 0;
      span:last-child {
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 31px;
        text-align: center;
        color: #38ba7c;
      }
    }
    .transfer-text {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 17px;
      letter-spacing: 0.02em;
      color: #999999;
      width: 100%;
      overflow-wrap: break-word;
      margin-bottom: 40px;
    }
    .input-title {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 8px;
      color: #666666;
    }
    .transfer-input {
      width: 264px;
      background: #f6f6f6;
      border-radius: 4px;
      height: 40px;
      line-height: 40px;
      padding-left: 10px;
      margin-bottom: 14px;
      border: 1px solid #e9e9e9;
      background-color: #f9f9f9;
      border-radius: 6px;
    }
    .error-text {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: #fd2243;
    }
    .transfer-btn {
      width: 191px;
      height: 48px;
      background: $color-yellow;
      margin-top: 60px;
      border-radius: 50px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.000319808px;
      color: $color-gray-1;
      cursor: pointer;
    }
  }
}
</style>
